// ============================================================
// AssistantBar — noar-e shenavar-e dastyar (mic + type + panel)
// Mostaghel az draw() chrkhe-ye CompanyDashboard.
// Text-chat + Gemini Live voice, herdo az tarigh-e backend (/api/voice/*).
//
// FASSADE: die drei öffentlichen Exporte (mountAssistantBar,
// startMobileVoice, stopMobileVoice) sind UNVERÄNDERT — Konsumenten
// (CompanyDashboard.js, LeadMobileView.tsx) bleiben unangetastet.
// Die Implementierung lebt jetzt in:
//   • engine/  — imperativer, React-freier Kern (Voice-Session, Text-Chat,
//                Tool-Ausführung, Verlauf, Formulare, Headless-Steuerung)
//   • react/components/assistant/ — die React-Insel (Dock, Panel, Chat,
//                Verlauf, Formulare, Orb) mit den CSS-Klassen aus
//                assistant-bar.css (Datei unverändert)
// ============================================================
import './assistant-bar.css';
import { mountReact } from '../../react/lib/mountReact.tsx';
import { AssistantBarApp } from '../../react/components/assistant/AssistantBarApp.tsx';
import { AssistantEngine } from './engine/AssistantEngine.ts';
import { installAssistantGlobalUiHandlers } from './engine/globalUi.ts';

let mounted = false;

// ── Headless-Voice-API (Mobile Lead-UI) ─────────────────────
// Der Mic in der mobilen Bottom-Nav startet die Sprachsitzung OHNE Panel/
// Overlay — die einzige Anzeige ist der animierte Nav-Button selbst.
// mountAssistantBar füllt die Engine; die Mobile-UI ruft start/stop und bekommt
// Zustandswechsel über onState: 'connecting' | 'live' | 'stopped' | 'error'
// | 'visual' (ein Voice-Tool brauchte UI → Panel wurde doch geöffnet).
let engine = null;
// onActivity (optional): bekommt während einer Tool-Ausführung ein übersetztes
// Label («Arbeitet an der Offerte …») und danach null — die Mobile-UI zeigt
// daraus den Aktivitäts-Chip am Orb (im Headless-Betrieb gibt es sonst KEINE
// Anzeige, dass die KI gerade etwas tut).
export function startMobileVoice(onState, onActivity) {
  if (!engine) return false;
  engine.startHeadless(onState, onActivity);
  return true;
}
export function stopMobileVoice() {
  if (engine) engine.stopVoice();
}

export function mountAssistantBar(root) {
  if (mounted) return;          // jelogiri az do-baare sakht
  if (!root) return;
  mounted = true;

  // SCROLL + TAP_TARGET: shell-agnostische Voice-Gesten — wie bisher genau
  // einmal beim Mount registriert (engine/globalUi.ts).
  installAssistantGlobalUiHandlers();

  // Engine SOFORT erzeugen (synchron): die Mobile-UI ruft direkt nach
  // mountAssistantBar() schon startMobileVoice() — Headless braucht kein DOM.
  engine = new AssistantEngine();

  // dock-e mostaghel — birun az #cd-root, mostaghim be root ezafe mishavad.
  // Der Container selbst ist unsichtbar (statisch, 0×0) — .ab-dock/.ab-overlay
  // darin sind position:fixed wie zuvor.
  const container = document.createElement('div');
  container.className = 'ab-react-root';
  root.appendChild(container);
  mountReact(container, AssistantBarApp, { engine });
}
